import styled from 'styled-components'

import '@fontsource/plus-jakarta-sans'

export const ListContainer = styled.div`
  width: 300px;
  background-color: #fdfdfd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(100vh - 185px);
  overflow-y: scroll;
  scrollbar-color: #bdddeb white;
  scrollbar-width: thin;

  @media screen and (max-width: 1024px) {
    width: 220px;
  }

  @media screen and (max-width: 768px) {
    width: calc(100vw - 20px);
    height: fit-content;
    max-height: calc(100vh - 180px);
    overflow-y: hidden;
    transition: width 0.3s ease;

    &.open {
      width: 240px;
    }
  }
`

export const TitleContainer = styled.div`
  padding: 8px 24px;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 8px 10px;
  }
`

export const ListIconTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ListIcon = styled.div`
  cursor: pointer;

  svg {
    font-size: 30px;
    color: #000000;
  }
`

export const List = styled.div`
  width: 100%;

  @media screen and (max-width: 768px) {
    overflow-y: scroll;
    scrollbar-color: #bdddeb white;
    scrollbar-width: thin;
    height: 0px;
    transition: height 5s ease;

    &.open {
      height: fit-content;
    }
  }
`
